import React from "react";
import { Helmet } from "react-helmet-async";
import FrequentQuestion, {
	type FrequentQuestionProps,
} from "../../../components/FrequentQuestion";
import * as styles from "./ParagraphFAQ.module.scss";

import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphFAQProps {
	heading: string;
	jumpLinksTitle?: string;
	faqs: FrequentQuestionProps[];
}

export const getParagraphFAQProps = ({
	field_heading,
	field_jump_links_title,
	relationships: { field_faq },
}: Queries.ParagraphFAQsDataFragment): ParagraphFAQProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	faqs: field_faq.map((commonQuestion, i) => ({
		question: commonQuestion.field_question,
		answer: commonQuestion.field_answer.value,
		isRTE: true,
		isFirst: i === 0,
		jumpLinksQuestionTitle: commonQuestion.field_jump_links_title,
	})),
});

export const ParagraphFAQ: React.FC<ParagraphFAQProps> = ({
	heading,
	jumpLinksTitle,
	faqs,
}) => {
	const schema = {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: [
			faqs.map((commonQuestion) => ({
				"@type": "Question",
				name: `${commonQuestion.question}`,
				acceptedAnswer: {
					"@type": "Answer",
					text: `${commonQuestion.answer}`,
				},
			})),
		],
	};

	return (
		<WrappedSection sectionName="ParagraphFAQ">
			<Helmet>
				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>

			<div className={styles.paragraphfaqinner}>
				<header className={styles.faqheading}>
					{jumpLinksTitle ? (
						<h2 data-jumplinkstitle={jumpLinksTitle} className={styles.heading}>
							{heading || "FAQs"}
						</h2>
					) : (
						<h2 className={styles.heading}>{heading || "FAQs"}</h2>
					)}
				</header>
				<div className={styles.cards}>
					{faqs.map((commonQuestion, i) => (
						<FrequentQuestion
							key={`${commonQuestion.title}-${i}`}
							{...commonQuestion}
						/>
					))}
				</div>
			</div>
		</WrappedSection>
	);
};

export default ParagraphFAQ;
